import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    Output,
    TemplateRef,
    ViewChild,
} from '@angular/core';

import { CmpsUser } from '../public-api';

import { CmpsInsightCoachingPerformanceData } from './insight-coaching-performance.metadata';
@Component({
    selector: 'cmps-insight-coaching-performance',
    template: `
        <div class="cmps-insight-coaching-performance--container">
            <div
                class="cmps-insight-coaching-performance--row"
                (click)="toggleExpand.emit()"
            >
                <div
                    class="cmps-insight-coaching-performance--column"
                    #pillarName
                >
                    <div
                        class="cmps-insight-coaching-performance--pillar-name"
                        (click)="toggleExpand.emit(); $event.stopPropagation()"
                        *ngIf="!user"
                    >
                        <cmps-icon
                            [cmpsTooltipTrigger]="expandCollapseTooltip"
                            [svgIcon]="
                                isExpanded
                                    ? '__internal:chevron-up'
                                    : '__internal:chevron-down'
                            "
                        ></cmps-icon>
                        <span
                            class="cmps-cdk-line-clamp-2 cmps-cdk-text-overflow-ellipsis"
                            [cmpsTooltipTrigger]="label"
                            >{{ label }}</span
                        >
                    </div>

                    <!-- User component -->
                    <ng-container *ngIf="user">
                        <cmps-metric-user
                            [user]="user"
                            [showArrow]="true"
                            (onUserClick)="onUserClick(user)"
                        >
                        </cmps-metric-user>
                    </ng-container>
                </div>

                <div class="cmps-insight-coaching-performance--column">
                    <div
                        class="cmps-insight-coaching-performance--progress-bar"
                    >
                        <ng-container *ngFor="let i of data">
                            <div
                                class="cmps-insight-coaching-performance--progress-bar-section-wrapper"
                                [style.width]="i.percent"
                                *ngIf="i.metricsLength > 0"
                            >
                                <ng-template #performanceTooltip>
                                    <ng-container
                                        *ngFor="let n of i.tooltipData"
                                    >
                                        <div
                                            class="cmps-insight-coaching-performance--tooltip-content"
                                        >
                                            <span
                                                class="cmps-insight-coaching-performance--child-title"
                                                [class]="n?.className"
                                            >
                                                {{ n.title }}
                                            </span>
                                            <span
                                                class="cmps-insight-coaching-performance--child-number"
                                                [class]="n?.className"
                                            >
                                                {{ n.number }}
                                            </span>
                                        </div>
                                    </ng-container>
                                </ng-template>
                                <button
                                    cmpsIconButton
                                    [class.cmps-insight-coaching-performance--progress-bar-disabled]="
                                        !i.enabled
                                    "
                                    class="cmps-insight-coaching-performance--progress-bar-filled"
                                    [cmpsTooltipTrigger]="performanceTooltip"
                                    placement="top-center"
                                    [style.background]="
                                        i.backgroundColorGradient
                                    "
                                    (click)="selectedValue.emit(i)"
                                ></button>
                                <span>{{ i.metricsLength }}</span>
                            </div>
                        </ng-container>
                    </div>
                    <button
                        class="cmps-metric-performance--launch"
                        cmpsIconButton
                        [cmpsTooltipTrigger]="launchButtonTooltip"
                        (click)="
                            $event.stopPropagation(); launchAction.emit($event)
                        "
                        *ngIf="hasLaunchButton"
                    >
                        <cmps-icon
                            class="cmps-metric-performance--launch-button"
                            svgIcon="__internal:launch"
                        ></cmps-icon>
                    </button>
                </div>
            </div>
            <div class="action-buttons">
                <ng-container *ngTemplateOutlet="actionButtons"></ng-container>
            </div>

            <div class="row-body">
                <ng-container *ngTemplateOutlet="childPillar"></ng-container>
            </div>
        </div>
    `,
    host: {
        class: 'cmps-insight-coaching-performance',
        '[class.cmps-insight-coaching-performance--total-performance]':
            'isTotalPerformance',
    },
})
export class CmpsInsightCoachingPerformanceComponent {
    @ViewChild('pillarName') pillarName: ElementRef;

    @Input() isTotalPerformance: boolean;
    @Input() label: string;
    @Input() expandCollapseTooltip: string;
    @Input() isExpanded: boolean;
    @Input() launchButtonTooltip: string;
    @Input() hasLaunchButton: boolean;
    @Input() user: CmpsUser;

    @Input() data: CmpsInsightCoachingPerformanceData;
    @Input() childPillar: TemplateRef<any> | null;
    @Input() actionButtons: TemplateRef<any> | null;

    @Output() selectedValue: EventEmitter<MouseEvent | KeyboardEvent>;
    @Output() toggleExpand: EventEmitter<MouseEvent | KeyboardEvent>;
    @Output() launchAction = new EventEmitter<MouseEvent | KeyboardEvent>();
    @Output() onUserClickAction: EventEmitter<MouseEvent | KeyboardEvent>;

    constructor() {
        this.selectedValue = new EventEmitter();
        this.toggleExpand = new EventEmitter();
        this.launchAction = new EventEmitter();
        this.onUserClickAction = new EventEmitter();
    }

    onUserClick(event: MouseEvent | KeyboardEvent): void {
        this.onUserClickAction.emit(event);
    }

    ngOnDestroy(): void {
        this.selectedValue.complete();
        this.toggleExpand.complete();
        this.launchAction.complete();
        this.onUserClickAction.complete();
    }
}
